import { useEffect, useState } from 'react'

const COPIED_RESET_MS = 2000

export interface CopyToClipboard {
  hasCopied: boolean
  copy: (value: string) => Promise<void>
}

/**
 * Copies a value and flips `hasCopied` for a couple of seconds so the caller
 * can swap its label/icon to a confirmation. Mirrors the legacy Setup tab's
 * `EditEntitySubTitle` behaviour.
 */
export const useCopyToClipboard = (): CopyToClipboard => {
  'use memo'

  const [hasCopied, setHasCopied] = useState(false)

  useEffect(() => {
    if (!hasCopied) {
      return
    }
    const timer = setTimeout(() => setHasCopied(false), COPIED_RESET_MS)
    // Cleared on unmount so a copy right before switching teams cannot set
    // state on an unmounted component.
    return () => clearTimeout(timer)
  }, [hasCopied])

  const copy = async (value: string) => {
    try {
      await navigator?.clipboard?.writeText(value)
      setHasCopied(true)
    } catch {
      setHasCopied(false)
    }
  }

  return { hasCopied, copy }
}
